/* eslint-disable */
// import { useHistory } from 'react-router';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import styles from './ProductionPlan.module.scss';
import { ListTable } from '../../Components/ListTable';
import { classes, filtersInfoChip, getOrderType, multiplePoCustomers, useQuery } from '../../Helpers';
import { analyticsAction, formActions, modalActions } from '../../Actions';
import { AlertModal, ProductionPlanModal, CreateOrdersModal } from '../../Components/Modals';
import ProductPlanHeader from './ProductPlanHeader/ProductPlanHeader';
import productionPlanServices from '../../Services/Analytics Services/production-plan.services';
import { urls } from '@/Constants';
import { CalendarRange, Eye, FileSpreadsheet, Pencil, X } from 'lucide-react';
import { Tooltip } from '@mui/material';
import moment from 'moment';
import { notificationServices } from '@/Services';
import { useAuth } from '@/Components/Auth/Login/auth';
import { Button } from '@/Components/ui/button';
import MultiPoModal from '@/Components/Modals/MultiPoModal/multiPoModal';
import inventoryAnalyticsServices from '@/Services/Analytics Services/inventory-analytics.services';
import { transformLongTermPlanApiResponse } from '@/Components/Modals/MultiPoModal/utils/utils';
import Tab from '@/Components/InfoTab/tab';
import ImagesFinder from '@/Components/ImagesFinder/ImagesFinder';
import drawerActions from '@/Actions/drawer.actions';
import { notShowmultipleOrders } from '@/config/config';
import userRolesAndPermissions from '@/Services/userRolesAndPermissions.services';
import cookingRecipesServices from '@/Services/Form Services/cookingRecipes.services';
import InitiateProductionPlanModal from './InitiateProductionPlanModal/InitiateProductionPlanModal';
// import { ArrangePages } from '../../../Components/Arrange Pages';

const getTabList = (isFilteredByLpp) => [
	{
		label: 'Daily Plans',
		value: 'daily',
	},
	{
		label: 'Long Term Plans',
		value: 'longTerm',
	},
];

// Filters info for ImagesFinder

const COLMAP = {
	'Production Plan ID': 'id',
	'Fulfilled Store': 'store',
	'Initiated By': 'initiatedBy',
	'Long Term Plan ID': 'id',
	'Production Plan Name': 'description',
	'Ordering Outlets': 'storeCount',
	'Item Count': 'itemCount',
	'Planned Tonnage': 'totalProduction',
	'Generated Date': 'createdAt',
	'Scheduled for': 'scheduledAt',
	'Status': 'status',
};

const TABLE_COLUMNS = [
	{
		title: 'Production Plan ID',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Production Plan Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Ordering Outlets',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Item Count',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Planned Tonnage',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Initiated By',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Generated Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Scheduled for',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Status',
		config: {
			type: 'DATA',
		},
	},
];

const SPECIAL_COLUMNS = [
	{
		title: 'long Term Plan Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Fulfilled Store',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Action',
		config: {
			type: 'DATA',
		},
	}
];

const ACTION_COLUMNS = [
	{
		title: 'View More',
		config: {
			type: 'VIEW',
		},
	},
];

// Long Term Production Plan columns
const LONGTERM_COLMAP = {
	'Plan ID': 'id',
	'Plan Name': 'name',
	'Type': 'type',
	'Shift': 'shiftId',
	'Start Date': 'startDate',
	'End Date': 'endDate',
	'Store': 'storeId',
};

const LONGTERM_TABLE_COLUMNS = [
	{
		title: 'Plan ID',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Plan Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Shift',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Start Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'End Date',
		config: {
			type: 'DATA',
		},
	},
];

const LONGTERM_ACTION_COLUMNS = [
	{
		title: 'Store',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Action',
		config: {
			type: 'DATA',
		},
	},
];

const ProductionPlans = (props) => {
	const { data, toggleProductionPlanModal, stores, fetchStoresList, navState, fetchProductionPlans, getIngredients } = props;
	const query = useQuery();
	const id = query?.get('id');
	const date = query?.get('date');
	const openModal = query?.get('openModal');
	const notification = query?.get('notification');
	const navRequisites = navState?.[urls.SALES_ORDERS]?.requisites ?? [];
	const navSelectedStore = navRequisites?.find((ele) => {
		return ele?.type === 'store';
	});
	const [tabValue, setTabValue] = useState('daily');
	const [search, setSearch] = useState(null);
	const [filterValue, setFilterValue] = useState({});
	const [longTermData, setLongTermData] = useState([]);
	const orderDataKey = query?.get('orderDataKey');
	let orderData = null;

	if (orderDataKey) {
		try {
			const storedData = sessionStorage.getItem(orderDataKey);
			orderData = storedData ? JSON.parse(storedData) : null;
		} catch (error) {
			console.error('Error parsing order data from session storage:', error);
			orderData = null;
		}
	}

	const dispatch = useDispatch();
	const { userConfig = {}, appConfig = {} } = useAuth();
	const { level } = userConfig?.userDetails || {};
	const isA2bCustomer = !multiplePoCustomers.includes(appConfig?.customerId);
	const isShowMultiple = notShowmultipleOrders.includes(appConfig?.customerId);
	const isWynBrands = appConfig?.customerId === 67;
	const productList = useSelector(
		(state) => state?.form?.ALL_PRODUCTS?.data?.LIST
	);
	const batches = useSelector((state) => state?.analytics?.INGREDIENT_LIST);
	const shiftList = useSelector((state) => state?.analytics?.SHIFT_LIST);
	const [filteredLppId, setFilteredLppId] = useState(null);
	const isModalOpen = useSelector((state) => state?.modal?.multiplePoModal?.show);
	const prevModalState = useRef(false);

	useEffect(() => {
		if (orderDataKey) {
			const cleanup = setTimeout(() => {
				sessionStorage.removeItem(orderDataKey);
			}, 1000);

			return () => clearTimeout(cleanup);
		}
	}, [orderDataKey]);

	useEffect(() => {
		if (openModal) {
			handleOpenLongTermModal();
		}
	}, [openModal]);

	useEffect(() => {
		if (prevModalState.current && !isModalOpen) {
			handleFetchProductionPlans(filterValue);
		}
		prevModalState.current = isModalOpen;
	}, [isModalOpen]);

	const filtersInfo = {
		'header': {
			store: false,
			date: false,
			...(tabValue === 'daily' ? { process: false } : { process: true }),
		},
		'kitchenBaseStore': {
			show: true,
			text: 'Select Base Kitchen',
		},
		...(tabValue === 'daily' ? {
			'longTermPlan': {
				show: true,
				text: 'Long Term Plan',
			}
		} : {}),
		'dateRangeOnly': {
			show: true,
			text: 'Date Range',
		},
	};

	const fetchPosAgainstPP = async (item, mode = 'edit', cb) => {
		const req = {
			data: {
				filters: {
					generatedPPId: item?.id,
				},
			},
		};
		try {
			const response = await inventoryAnalyticsServices?.fetchPoList({ req });
			if (response?.statusCode === 200) {
				cb(response?.data, mode, item);
			}
		} catch (error) {
			console.log(error, 'error');
		}
	};

	const handleProductionPlan = async (data, mode, item) => {
		const shiftIds = data?.filter((ele) => ele?.shiftId != null)?.map((ele) => ele?.shiftId);
		const uniqueShiftIds = [...new Set(shiftIds)];
		if (uniqueShiftIds.length > 1) {
			const shiftIdMap = {};
			data.forEach((po) => {
				const shiftKey = po?.shiftId ?? 'null';
				if (!shiftIdMap[shiftKey]) shiftIdMap[shiftKey] = [];
				shiftIdMap[shiftKey].push(po?.id);
			});
			const details = Object.entries(shiftIdMap)
				.map(([shift, ids]) => `Shift: ${shift} => PO IDs: [${ids.join(', ')}]`)
				.join('\n');
			notificationServices.generateNotification({
				type: 'error',
				message: `Cannot proceed: POs have different shift IDs.\n${details}`,
			});
			return;
		}

		// Determine shiftId to send: use the unique one if exists, otherwise null
		const resolvedShiftId = uniqueShiftIds.length > 0 ? uniqueShiftIds[0] : null;

		const req = {
			params: {
				planId: item?.id,
			},
		};
		try {
			const response = await productionPlanServices.getPlanDetails(req);
			if (response?.statusCode === 200) {
				const isViewMode = mode === 'view';
				toggleProductionPlanModal(true, {
					idsList: data?.map((ele) => ele?.id),
					listData: response?.data,
					date: moment(item?.scheduledAt).format('YYYY-MM-DD'),
					storeId: item?.store,
					lppId: response?.data?.lppId ?? item?.lppId,
					productionPlanId: item?.id,
					...(isViewMode ? { hideButtons: true, nonEditable: true } : { editMode: true }),
					...(resolvedShiftId != null || response?.data?.shiftId != null && { shiftId: response?.data?.shiftId || resolvedShiftId }),
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	}

	const handleCancelProductionPlan = async (item) => {
		const req = {
			data: {
				planId: item?.id,
			},
		};
		try {
			const response = await productionPlanServices.cancelProductionPlan(req);
			if (response?.statusCode === 200) {
				notificationServices?.generateNotification({
					type: 'success',
					message: 'generated production plan cancelled successfully'
				})
				dispatch(modalActions?.toggleAlert(false));
				handleFetchProductionPlans(filterValue);
			}
		} catch (error) {
			console.log('error', error);
		}
	}

	const handleConfirmation = (item) => {
		dispatch(modalActions?.toggleAlert(true, {
			title: 'Cancel Production Plan',
			message: `Are you sure you want to cancel this production plan ${item?.description}?`,
			handleConfirm: () => handleCancelProductionPlan(item)
		}))
	}

	const handleCancelLongTermPlan = async (item) => {
		const req = {
			data: {
				lppId: item?.id,
			},
		};
		try {
			const response = await productionPlanServices.cancelLongTermProductionPlan(req);
			if (response?.statusCode === 200) {
				notificationServices?.generateNotification({
					type: 'success',
					message: response?.message || 'Long term production plan cancelled successfully',
				});
				dispatch(modalActions?.toggleAlert(false));
				handleFetchProductionPlans(filterValue);
			}
		} catch (error) {
			console.log('error', error);
		}
	};

	const handleLongTermCancelConfirmation = (item) => {
		dispatch(modalActions?.toggleAlert(true, {
			title: 'Cancel Long Term Plan',
			message: `Are you sure you want to cancel the long term plan "${item?.name}"? Daily plans already generated from it will not be affected and can be cancelled individually.`,
			handleConfirm: () => handleCancelLongTermPlan(item),
		}));
	};

	const handleClose = () => {
		dispatch(modalActions?.toggleProductionPlanModal(false));
		handleFetchProductionPlans(filterValue);
	}

	function handleOpenMultiPoModal(data, mode, item = {}) {
		if (!data || data.length === 0) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'No Orders found Associated with this Production Plan.',
			});
			return;
		}
		const fromStore = data?.map((item) => item?.fromStore);
		const cmsPos = data?.filter((po) => getOrderType(po?.type) === 'CMS') ?? [];
		const shiftIds = cmsPos.map((item) => item?.shiftId);
		const toProcessIds = cmsPos.map((item) => item?.toProcessId);
		const scheduledAts = data?.map((item) => (
			item?.scheduledAt
				? moment(item.scheduledAt).format('YYYY-MM-DD')
				: null
		));
		const haveSameValue = (arr) => arr?.every((item) => item === arr[0]);
		const navSelectedStore = {};

		let errorMessages = [];
		if (fromStore?.length > 1 && !haveSameValue(fromStore)) {
			errorMessages.push('Please select POs with the same from store.');
		} else {
			navSelectedStore.value = {
				id: fromStore[0],
				name: data[0]?.fromStoreName,
			};
		}
		if (shiftIds?.length > 1 && !haveSameValue(shiftIds)) {
			const shiftIdMap = {};
			cmsPos.forEach(po => {
				if (!shiftIdMap[po?.shiftId]) shiftIdMap[po?.shiftId] = [];
				shiftIdMap[po?.shiftId].push(po?.id);
			});
			const details = Object.entries(shiftIdMap)
				.map(([shift, ids]) => `Shift: ${shift || '-'} => PO IDs: [${ids.join(', ')}]`)
				.join('\n');
			errorMessages.push(`Please select POs with the same shift.\n${details}`);
		}
		if (toProcessIds?.length > 1 && !haveSameValue(toProcessIds)) {
			const processIdMap = {};
			cmsPos.forEach(po => {
				if (!processIdMap[po?.toProcessId]) processIdMap[po?.toProcessId] = [];
				processIdMap[po?.toProcessId].push(po?.id);
			});
			const details = Object.entries(processIdMap)
				.map(([proc, ids]) => `ToProcessId: ${proc || '-'} => PO IDs: [${ids.join(', ')}]`)
				.join('\n');
			errorMessages.push(`Please select POs with the same ProcessId.\n${details}`);
		}
		if (scheduledAts?.length > 1 && !haveSameValue(scheduledAts)) {
			const scheduledAtMap = {};
			data.forEach(po => {
				const dateKey = po?.scheduledAt
					? moment(po.scheduledAt).format('YYYY-MM-DD')
					: '-';
				if (!scheduledAtMap[dateKey]) scheduledAtMap[dateKey] = [];
				scheduledAtMap[dateKey].push(po?.id);
			});
			const details = Object.entries(scheduledAtMap)
				.map(([date, ids]) => `Expected Delivery Date: ${date || '-'} => PO IDs: [${ids.join(', ')}]`)
				.join('\n');
			errorMessages.push(`Please select POs with the same expected delivery date.\n${details}`);
		}

		if (errorMessages.length) {
			notificationServices.generateNotification({
				type: 'error',
				message: errorMessages.join('\n\n'),
			});
			return;
		}
		const invalidPos = data.filter((po) =>
			(po?.items || []).some(
				(it) => (it?.packaged ?? 0) > 0 || (it?.fulfilled ?? 0) > 0
			)
		);

		if (invalidPos.length && mode === 'edit') {
			notificationServices.generateNotification({
				type: 'error',
				message: `These POs have packaged/fulfilled items and cannot be edited: ${invalidPos
					.map((p) => p?.id)
					.join(', ')}`,
			});
			return;
		}

		if (mode === 'edit') {
			dispatch(modalActions.toggleMultiplePoModal(true, {
				navSelectedStore: navSelectedStore,
				editMode: true,
				selectedPOs: data,
				ppId: item?.id,
			}));
		} else {
			dispatch(modalActions.toggleMultiplePoModal(true, {
				viewMode: true,
				selectedPOs: data,
				navSelectedStore: navSelectedStore,
			}));
		}
	}

	const SPECIAL_ITEMS = {
		'Status': (value, obj) => {
			const status = (value || '').toLowerCase();
			let bgClass = '';
			let textClass = '';
			switch (status) {
				case 'cancelled':
					bgClass = 'bg-red-100';
					textClass = 'text-red-700';
					break;
				case 'in progress':
					bgClass = 'bg-orange-100';
					textClass = 'text-orange-700';
					break;
				case 'initiated':
					bgClass = 'bg-blue-100';
					textClass = 'text-blue-700';
					break;
				case 'completed':
					bgClass = 'bg-green-100';
					textClass = 'text-green-700';
					break;
				default:
					bgClass = 'bg-gray-100';
					textClass = 'text-gray-700';
			}
			return (
				<div
					className={`px-3 py-1 w-[7rem] rounded-md text-center font-semibold capitalize inline-block ${bgClass} ${textClass}`}
				>
					{status}
				</div>
			)
		},
		'long Term Plan Id': (id) => {
			const item = data?.find((ele) => {
				return ele?.id === id;
			});
			return (
				<div>{item?.lppId}</div>
			)
		},
		'Fulfilled Store': (id) => {
			const item = data?.find((ele) => {
				return ele?.id === id;
			});
			const store = stores?.find((ele) => {
				return ele?.id === item?.store;
			});
			return (
				<div
					style={{
						width: '200px',
					}}
				>
					{store?.name}
				</div>
			);
		},
		'Ordering Outlets': (value) => {
			return (
				<span className='text-[14px]'>
					No. of Outlets: {value}
				</span>
			);
		},
		'Planned Tonnage': (value) => {
			const numValue = Number(value);
			const formattedValue = Number.isInteger(numValue) ? numValue : numValue.toFixed(2);
			const displayValue = `${formattedValue} Kg`;
			const isLong = displayValue.length > 10;
			const content = (
				<span className={`text-[14px]  ${isLong ? 'truncate w-[60px] block' : ''}`}>
					{displayValue}
				</span>
			);

			if (isLong) {
				return (
					<Tooltip title={displayValue} placement="top" arrow>
						{content}
					</Tooltip>
				);
			}
			return content;
		},
		'Item Count': (value) => {
			return (
				<span>
					{value}
				</span>
			);
		},
		'Action': (id) => {
			const item = data?.find((ele) => ele?.id === id);
			const isLongTerm = item.lppId;
			if (item?.status?.toLowerCase() === 'initiated') {
				return (
					<div className='flex gap-3'>
						{!isWynBrands && (
							<Tooltip title='Edit Sales Orders'>
								<Button
									onClick={() => fetchPosAgainstPP(item, 'edit', handleOpenMultiPoModal)}
									className="p-1 rounded bg-yellow-600 hover:border-yellow-600"
								>
									<FileSpreadsheet className='text-yellow-400' />
								</Button>
							</Tooltip>
						)}
						{
							!isLongTerm && (
								<Tooltip title='Edit Production Plan'>
									<button
										type='button'
										className='p-1 rounded bg-blue-600 hover:bg-blue-600'
										style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
										onClick={() => fetchPosAgainstPP(item, 'edit', handleProductionPlan)}
									>
										<Pencil className='text-blue-400' />
									</button>
								</Tooltip>
							)
						}
						<Tooltip title='Cancel Production Plan'>
							<button
								type='button'
								className='p-1 rounded bg-red-600 hover:bg-red-600'
								style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
								onClick={() => handleConfirmation(item)}
							>
								<X className='text-white' />
							</button>
						</Tooltip>
					</div>
				);
			}
			return null;
		}
	};

	// Long Term Special Items
	const LONGTERM_SPECIAL_ITEMS = {
		'Store': (id) => {
			const item = longTermData?.find((ele) => ele?.id === id);
			const store = stores?.find((ele) => ele?.id === item?.storeId);
			return (
				<div>
					{store?.name || '-'}
				</div>
			);
		},
		'Plan Name': (val, obj) => {
			return (
				<div className='w-[200px] word-break break-words'>
					{val || '-'}
				</div>
			);
		},
		'Type': (value) => {
			return (
				<div className='capitalize'>
					{value}
				</div>
			);
		},
		'Shift': (id) => {
			const shift = shiftList?.find((ele) => ele?.id === id);
			return (
				<div>
					{shift?.shiftName
						|| '-'}
				</div>
			);
		},
		'Action': (id) => {
			const item = longTermData?.find((ele) => ele?.id === id);
			return (
				<div className='flex gap-3'>
					<Tooltip title='Review Long Term Plan'>
						<Button
							onClick={() => handleReviewLongTermPlan(item)}
							className='p-1 rounded bg-yellow-600 hover:border-yellow-600'
						>
							<CalendarRange className='text-yellow-400' />
						</Button>
					</Tooltip>
					<Tooltip title='View Associated Plans'>
						<Button
							onClick={() => handleViewDailyPlans(item)}
							className='p-1 rounded bg-blue-600 hover:bg-blue-600'
						>
							<Eye className='text-blue-400' />
						</Button>
					</Tooltip>
					<Tooltip title='Cancel Long Term Plan'>
						<button
							type='button'
							className='p-1 rounded bg-red-600 hover:bg-red-600'
							style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
							onClick={() => handleLongTermCancelConfirmation(item)}
						>
							<X className='text-white' />
						</button>
					</Tooltip>
				</div>
			);
		}
	};

	const handleViewDailyPlans = (item) => {
		setTabValue('daily');
		setFilteredLppId(item?.id);
	};

	const handleReviewLongTermPlan = async (item) => {
		if (!productList || productList.length === 0) {
			notificationServices.generateNotification({
				type: 'warning',
				message: 'Product list is not loaded yet. Please wait a moment or refresh the page.',
			});
			return;
		}
		try {
			let storeBatches = batches;
			if (item?.storeId) {
				try {
					const batchRes = await cookingRecipesServices.fetchIngredientDirect({
						req: { params: { storeId: item?.storeId } },
					});
					if (Array.isArray(batchRes?.data)) {
						storeBatches = batchRes?.data;
					}
				} catch (batchErr) {
					console.error('Error fetching store batches for long term plan:', batchErr);
				}
			}
			const response = await productionPlanServices.getLongTermProductionPlan({
				params: {
					id: item?.id,
				},
			});
			if (response?.statusCode === 200) {
				const planData = response?.data;
				const { headers: transformedHeaders, rows: transformedRows, initialState, workerAllocations, missingProducts } = transformLongTermPlanApiResponse(planData, productList, storeBatches);

				if (missingProducts && missingProducts.length > 0) {
					const uniqueMissing = [...new Set(missingProducts)];
					notificationServices.generateNotification({
						type: 'error',
						message: `The following products are missing or have undefined units: ${uniqueMissing.join(', ')}. Please refresh the page to sync data correctly.`,
						config: { duration: 10000 }
					});
					return;
				}

				dispatch(modalActions.toggleMultiplePoModal(true, {
					mode: 'longTermProduction',
					editMode: true,
					initialTableData: {
						headers: transformedHeaders,
						rows: transformedRows,
					},
					initialFieldsData: { ...initialState, generatedPlans: planData?.generatedPlans, workerAllocations },
				}));
			}
		} catch (error) {
			console.error('Error fetching long term plan:', error);
		}
	};


	useEffect(() => {
		fetchStoresList({
			entity: 'STORES',
			req: {
				params: {
					id: '',
				},
			},
			method: 'LIST',
		});
		if (shiftList?.length === 0) {
			dispatch(analyticsAction?.getShifts());
		}
		getIngredients();
	}, []);

	const getRowColor = (rowId) => {
		if (id == rowId) {
			return 'bg-[#FFF0C9]'
		}
		return '';
	};

	const viewMoreOptionsList = {
		'View Production Plan': async (item, cb) => {
			fetchPosAgainstPP(item, 'view', handleProductionPlan);
		},
		'View Work Order': async (item, cb) => {
			const query = [
				`productionPlan=${encodeURIComponent(JSON.stringify({ id: [item?.id], name: [item?.description] }))}`,
				`dateRange=${encodeURIComponent(JSON.stringify({
					active: true,
					from: item?.scheduledAt,
					to: item?.scheduledAt
				}))}`
			].join('&');
			window.open(`${urls?.EXTENSION}${urls?.FMS_ORDERS_LIST}?${query}`, '_blank');
		},
		'View Sales Order': async (item, cb) => {
			fetchPosAgainstPP(item, 'view', handleOpenMultiPoModal)
		}
	}

	const handleOpenModal = () => {
		dispatch(modalActions.toggleMultiplePoModal(true, {
			navSelectedStore: { fromStore: navSelectedStore?.value?.id },
		}))
	}

	const getColumns = () => {
		if (level !== 1) {
			return tabValue === 'longTerm' ? LONGTERM_ACTION_COLUMNS : [...SPECIAL_COLUMNS, ...ACTION_COLUMNS]
		}
		return tabValue === 'longTerm' ? [LONGTERM_ACTION_COLUMNS[0]] : [SPECIAL_COLUMNS[0], ...ACTION_COLUMNS]
	}

	useEffect(() => {
		if (notification) {
			handleOpenMultiPoModal(orderData, 'edit');
		}
	}, [notification]);

	const handleOpenLongTermModal = () => {
		dispatch(modalActions.toggleMultiplePoModal(true, {
			mode: 'longTermProduction',
		}))
	}

	const handleTabChange = async (value) => {
		setTabValue(value);
		setFilteredLppId(null);
		const dateRangeValues = {
			from: moment(filterValue?.dateRange?.from).format('YYYY-MM-DD'),
			to: moment(filterValue?.dateRange?.to).format('YYYY-MM-DD'),
		};
		const storeId = filterValue?.fromPodFilter?.id;
		if (value === 'longTerm') {
			// if (!storeId) {
			// 	dispatch(drawerActions.toggleFiltersDrawer(true));
			// 	return;
			// }
			const notificationId = notificationServices?.generateNotification({
				type: 'loading',
				message: 'Loading long term plans...'
			})
			try {
				const response = await productionPlanServices.listLongTermProductionPlan({
					data: {
						startDate: dateRangeValues?.from,
						endDate: dateRangeValues?.to,
						storeId: filterValue?.fromPodFilter?.id === -999 ? null : filterValue?.fromPodFilter?.id,
					}
				});
				if (response?.statusCode === 200) {
					setLongTermData(response?.data || []);
					notificationServices?.generateNotification({
						type: 'success',
						message: 'Long term plans loaded successfully',
						config: {
							id: notificationId
						}
					})
				}
			} catch (error) {
				console.error('Error fetching long term plans:', error);
				notificationServices?.generateNotification({
					type: 'error',
					message: 'Error fetching long term plans',
					config: {
						id: notificationId
					}
				})
			}
		} else {
			fetchProductionPlans({
				entity: 'PRODUCTION_PLANS',
				req: {
					data: {
						filters: {
							dateRangeFilter: dateRangeValues,
							populateStatus: true,
						},
					},
				},
				method: 'LIST',
			});
		}
	}

	const handleFetchProductionPlans = useCallback(async (finderFilters) => {
		setFilterValue(finderFilters);
		const dateRangeValues = {
			from: moment(finderFilters?.dateRange?.from).format('YYYY-MM-DD'),
			to: moment(finderFilters?.dateRange?.to).format('YYYY-MM-DD'),
		};
		if (tabValue === 'longTerm') {
			const notificationId = notificationServices?.generateNotification({
				type: 'loading',
				message: 'Loading long term plans...'
			})
			try {
				const response = await productionPlanServices.listLongTermProductionPlan({
					data: {
						startDate: dateRangeValues?.from,
						endDate: dateRangeValues?.to,
						storeId: finderFilters?.fromPodFilter?.id === -999 ? null : finderFilters?.fromPodFilter?.id,
					}
				});
				if (response?.statusCode === 200) {
					setLongTermData(response?.data || []);
					notificationServices?.generateNotification({
						type: 'success',
						message: 'Long term plans loaded successfully',
						config: {
							id: notificationId
						}
					})
				}
			} catch (error) {
				console.error('Error fetching long term plans:', error);
				notificationServices?.generateNotification({
					type: 'error',
					message: 'Error fetching long term plans',
					config: {
						id: notificationId
					}
				})
			}
		} else {
			fetchProductionPlans({
				entity: 'PRODUCTION_PLANS',
				req: {
					data: {
						filters: {
							...({ lppId: filteredLppId ? filteredLppId : finderFilters?.longTermPlan?.id ?? null }),
							dateRangeFilter: dateRangeValues,
							populateStatus: true,
						},
					},
				},
				method: 'LIST',
			});
		}
	}, [tabValue, fetchProductionPlans]);

	const handleSearch = (value) => {
		setSearch(value);
	};
	const filteredData = useMemo(() => {
		const sourceData = tabValue === 'longTerm' ? longTermData : data;
		if (!search?.searchValue || search?.searchValue?.trim() === '') {
			return sourceData;
		}

		const searchTerm = search?.searchValue?.toLowerCase()?.trim();
		const searchField = search?.value;

		return sourceData?.filter((item) => {
			const nameField = item?.description || item?.name || '';
			if (searchField === 'planId') {
				return item?.id?.toString()?.includes(searchTerm);
			} else if (searchField === 'planName') {
				return nameField?.toLowerCase()?.includes(searchTerm);
			}
			return (
				item?.id?.toString()?.includes(searchTerm) ||
				nameField?.toLowerCase()?.includes(searchTerm)
			);
		});
	}, [data, longTermData, tabValue, search?.searchValue, search?.value]);

	const handleOpenBuyerModal = () => {
		dispatch(modalActions.toggleMultiplePoModal(true, {
			mode: 'buyerOrder',
		}))
	};

	const handleOpenCreateOrdersModal = () => {
		dispatch(modalActions.toggleCreateOrdersModal(true, {
			navSelectedStore: { fromStore: navSelectedStore?.value?.id },
		}));
	};


	return (
		<div className={classes(styles.root, 'list-page-root')}>
			<ProductionPlanModal onCloseModal={handleClose} />
			<AlertModal />
			<MultiPoModal />
			<CreateOrdersModal />
			<InitiateProductionPlanModal
				onInitiated={() => handleFetchProductionPlans(filterValue)}
			/>
			<ImagesFinder
				onSubmit={handleFetchProductionPlans}
				filtersInfo={filtersInfo}
				preventDateRangeCheckbox
				selectedLppId={filteredLppId}
				exportInfo={{
					hideExportAccordian: true
				}}
			/>
			<ProductPlanHeader
				filtersValue={filterValue}
				filtersInfo={filtersInfo}
				openModal={handleOpenModal}
				handleOpenMultiPoModal={handleOpenMultiPoModal}
				isA2bCustomer={isA2bCustomer}
				openLongTermModal={handleOpenLongTermModal}
				handleSearch={handleSearch}
				level={level}
				openBuyerModal={handleOpenBuyerModal}
				openInitiateModal={() => dispatch(modalActions.toggleModal('initiateProductionPlanModal', true))}
				isShowMultiple={isShowMultiple}
				openCreateOrdersModal={handleOpenCreateOrdersModal}
			/>
			<div className='flex items-center justify-between'>
				<Tab
					tabList={getTabList(filteredLppId)}
					tabValue={tabValue}
					handleTabChange={handleTabChange}
				/>
				{filtersInfoChip(filtersInfo, filterValue)}
			</div>
			<div className='max-h-[calc(100vh-300px)] w-full overflow-auto text-[12px]'>
				<ListTable
					fixedHeaderTop={0}
					colMap={tabValue === 'longTerm' ? LONGTERM_COLMAP : COLMAP}
					hasDateRange
					special={tabValue === 'longTerm' ? LONGTERM_SPECIAL_ITEMS : SPECIAL_ITEMS}
					data={filteredData.map((obj) => {
						return {
							...obj,
							rowStyles: getRowColor(obj?.id)
						};
					})}
					columns={tabValue === 'longTerm' ? LONGTERM_TABLE_COLUMNS : TABLE_COLUMNS}
					actions={getColumns()}
					viewMoreOptionsList={tabValue === 'longTerm' ? {} : viewMoreOptionsList}
					showBtnContainer={false}
					emptyText={tabValue === 'longTerm' ? (!filterValue?.fromPodFilter?.id ? 'Please select a store to view long term production plans' : 'No Long Term Production Plans') : 'No Production Plans'}
				/>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const stores = state?.form?.STORES?.data?.LIST;
	const { navState } = state.navigation
	const { LIST: data } = state?.analytics.PRODUCTION_PLANS;
	return {
		data,
		stores,
		navState,

	};
};
const mapDispatchToProps = {
	toggleProductionPlanModal: modalActions.toggleProductionPlanModal,
	fetchProductionPlans: analyticsAction.gateway,
	fetchStoresList: formActions.gateway,
	getIngredients: analyticsAction.getIngredients,
};
export default connect(mapStateToProps, mapDispatchToProps)(ProductionPlans);
